module.exports = window["core-js/modules/es.string.includes.js"];